import { FC } from "react";
import { PlaceholderProps } from "react-select";

import { createComponentStyleHook } from "capitalrx-components-2.0/lib/tokens";
import classNames from "classnames";

import { OptionItem } from "../../OptionItem";

import tokenStyles from "./styles.module.css";
import legacyStyles from "./styles.module.scss";

const useResolvedDropdownPlaceholderStyles = createComponentStyleHook<PlaceholderProps<OptionItem | null>>({
  legacyStyles,
  tokenStyles,
  componentTokens: "dropdown_placeholder",
});

/**
 * The placeholder text component.
 */
export const Placeholder: FC<PlaceholderProps<OptionItem | null>> = (props) => {
  const { children, innerProps } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedDropdownPlaceholderStyles(props);

  const placeholderClassName = classNames(styles.Placeholder, "placeholder");

  return (
    <StyleModeBoundary mode={mode}>
      <div {...innerProps} className={placeholderClassName}>
        {children || <>&nbsp;</>}
      </div>
    </StyleModeBoundary>
  );
};
